
import { FlyerDto, FlyerPageDto } from '../../../../../dtos'
import { FlyerPage, IFlyerPageRef } from './flyerPage/FlyerPage'

// import { FlyerPagesArrows } from '../../../../com/flyerPages/arrows/FlyerPagesArrows'

import './FlyerPages.scss'
import { useRef, useState } from 'react'
import { useEffect } from 'react'

interface IFlyerPages {
    pageIndex: number,
    data?: FlyerDto,
    onLeftArrowClick: () => void,
    onNextArrowClick: () => void,
}

export const FlyerPages: React.FC<IFlyerPages> = (props) => {

    const flyerPageRef = useRef<IFlyerPageRef>(null)

    const [pageDto, setPageDto] = useState<FlyerPageDto | undefined>()

    useEffect(() => {
        flyerPageRef.current?.reInit();
        
        // flyerPageRef.current?.showLoader(true);
        var pageDto = props.data?.flyerPages![props.pageIndex]!
        setPageDto(pageDto)

    }, [props.data, props.pageIndex])

    return (
        <div className="flyer_pages_container">
            {/*<FlyerPagesArrows */}
            {/*    onLeftArrowClick={props.onLeftArrowClick}*/}
            {/*    onNextArrowClick={props.onNextArrowClick}*/}
            {/*/>*/}
            <FlyerPage ref={flyerPageRef} data={pageDto}/>
        </div>
    )
}